import * as React from 'react'
import { LifeInsuranceOffer } from 'ui/multi-product/constants/models'
import { formatCurrency } from 'ui/multi-product/utils'
import { MedicalBadge } from './MedicalBadge'

const styles = require('./styles')
interface OfferCardProps {
  offer: LifeInsuranceOffer
  handleOfferSelected: (offer: LifeInsuranceOffer) => void
  customSelection: boolean
}
export const OfferCard: React.FC<OfferCardProps> = (props) => (
  <div className={styles.liOfferCard}>
    <p className={styles.packageType} data-testid="li-offer-package">
      {props.customSelection ? 'Your Choice' : props.offer.details.packageType}
    </p>

    <p className={styles.offerPremium} data-testid="li-offer-premium">{`$${formatCurrency(
      props.offer.details.monthlyPremiumAmount,
    )}/mo`}</p>

    <p className={styles.offerTerm} data-testid="li-offer-term">
      {`${props.offer.details.termLength || 'unknown'} ${props.offer.details.termUnit?.toString() || 'year'}s at `}{' '}
      <span data-testid="li-offer-amount">{`$${formatCurrency(props.offer.details.policyAmount)}`}</span>
    </p>

    <MedicalBadge medicalExam={props.offer.details.medicalExam} />
    <button
      data-testid="li-offer-continue"
      className={styles.continueBtn}
      onClick={() => {
        props.handleOfferSelected(props.offer)
      }}
    >
      Continue
    </button>
  </div>
)
